













































































import { Component, Mixins, Prop, Emit } from 'vue-property-decorator'
import * as DateUtil from '@/tcw/utils/DateUtil'
import Jikan from '@/tcw/domain/Jikan'
import TcwFormItemCommon from '@/components/common/form/mixins/TcwFormItemCommon'

@Component
export default class TcwFormItemJikan extends Mixins(TcwFormItemCommon) {
  @Prop({ default: null })
  private kaishi!: Jikan | null
  @Prop({ default: null })
  private shuryo!: Jikan | null
  @Prop({ type: Boolean, default: false })
  private clearable!: boolean

  private day: Date | null = null
  private timeFormat: (date: Date) => string = (date: Date) => {
    return DateUtil.convertDateToStr(date, 'HH:mm')
  }
  private hourFormat = '24'

  @Emit('update:kaishi')
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private updateKaishi(value: Jikan | null): void {
    this.dateInput()
  }
  @Emit('update:shuryo')
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private updateShuryo(value: Jikan | null): void {
    /** */
  }

  @Emit()
  private dateInput(): void {
    /** */
  }

  private kaishiDateInput(kaishiValue: Date | null): void {
    let kaishiJikan: Jikan | null = null
    if (kaishiValue) {
      kaishiJikan = Jikan.generateByDate(kaishiValue)
    }
    this.updateKaishi(kaishiJikan)
    this.dateInput()
  }

  private shuryoDateInput(shuryoValue: Date | null): void {
    let shuryoJikan: Jikan | null = null
    if (shuryoValue) {
      shuryoJikan = Jikan.generateByDate(shuryoValue)
    }
    this.updateShuryo(shuryoJikan)
    this.dateInput()
  }

  private nowKaishi(): void {
    this.updateKaishi(this.getNow())
  }
  private clearKaishi(): void {
    this.updateKaishi(null)
  }
  private nowShuryo(): void {
    this.updateShuryo(this.getNow())
    this.dateInput()
  }
  private clearShuryo(): void {
    this.updateShuryo(null)
    this.dateInput()
  }
  private getNow(): Jikan {
    let nowDate = new Date()
    const nowJikan = Jikan.generateByDate(nowDate)
    const minuteMod = nowJikan.minuteValue % 15
    if (minuteMod >= 8) {
      nowJikan.minuteValue += 15 - minuteMod
    } else if (0 < minuteMod && minuteMod < 8) {
      nowJikan.minuteValue -= minuteMod
    }
    return nowJikan
  }

  private get isTeppenGoe(): boolean {
    if (!this.kaishi || !this.shuryo) {
      return false
    }

    // 開始日 > 終了日となっている場合は日付をまたいだと判断する
    return this.kaishi >= this.shuryo
  }
}
